(function () {
  'use strict';

  var root = document.getElementById('mpv-calc');
  if (!root) return;

  var money = function (c) { return '$' + (c / 100).toFixed(2); };
  var $ = function (id) { return document.getElementById(id); };

  var variants = [];
  try { variants = JSON.parse(document.getElementById('mpv-variants').textContent); } catch (e) { variants = []; }

  var cov = parseFloat(root.getAttribute('data-cov')) || 1;
  if (cov <= 0) cov = 1;
  var sealerId = root.getAttribute('data-sealer-id') || '';
  var sealerCents = parseInt(root.getAttribute('data-sealer-cents'), 10) || 0;
  var bushId = root.getAttribute('data-bush-id') || '';
  var bushCents = parseInt(root.getAttribute('data-bush-cents'), 10) || 0;
  var productTitle = root.getAttribute('data-product-title') || 'Paver';
  // Minimum order in pieces (pavers: 10; they ship by freight, too heavy for parcel). 0 = none (tiles, blocks).
  var moq = parseInt(root.getAttribute('data-moq'), 10) || 0;

  var cur = variants[0] || {
    id: parseInt(root.getAttribute('data-variant-id'), 10),
    price: parseInt(root.getAttribute('data-variant-price'), 10)
  };

  function selectedVariant() {
    var vr = document.querySelector('variant-radios') || document.querySelector('variant-selects');
    if (!vr || !variants.length) return cur;
    var checked = vr.querySelectorAll('input[type="radio"]:checked');
    var opts = [];
    if (checked.length) {
      checked.forEach(function (i) { opts.push(i.value); });
    } else {
      var sel = vr.querySelector('select');
      if (sel) {
        var m = variants.filter(function (v) { return String(v.id) === sel.value; })[0];
        return m || cur;
      }
      return cur;
    }
    var match = variants.filter(function (v) {
      for (var k = 0; k < opts.length; k++) {
        if (String(v.options[k]) !== String(opts[k])) return false;
      }
      return true;
    })[0];
    return match || cur;
  }

  function setText(id, t) { var e = $(id); if (e) e.textContent = t; }

  function placePerSqft() {
    var pe = $('mpv-price-sqft');
    if (!pe) return;
    var sec = pe.closest('.shopify-section') || document;
    var priceEl = sec.querySelector('.price');
    if (priceEl) {
      priceEl.classList.add('mpv-bigprice');
      if (priceEl.nextElementSibling !== pe) priceEl.insertAdjacentElement('afterend', pe);
    }
  }

  function variantName(v) {
    var n = (v && (v.option1 || (v.options && v.options[0]) || v.title)) || '';
    return (n && n !== 'Default Title') ? n : '';
  }

  function paverLabel() {
    var vn = variantName(cur);
    return productTitle + (vn ? ' — ' + vn : '') + ' (' + (root._qty || 0) + ' pcs)';
  }

  function updateStatic() {
    cur = selectedVariant();
    var psf = cur.price / cov;
    var pe = $('mpv-price-sqft');
    if (pe) pe.textContent = money(psf) + ' / sq ft';
    placePerSqft();
    var cname = cur.option1 || (cur.options && cur.options[0]) || '';
    var metaEl = $('mpv-sample-meta');
    if (metaEl) {
      if (root.getAttribute('data-sample-variant')) {
        metaEl.innerHTML = '— all colors';
      } else {
        metaEl.innerHTML = (cname && cname !== 'Default Title') ? 'in <b>' + cname + '</b>' : '';
      }
    }
  }

  function calc() {
    var sqEl = $('mpv-sqft');
    var sqft = sqEl ? (parseFloat(sqEl.value) || 0) : 0;
    var ovEl = root.querySelector('input[name="mpv-ov"]:checked');
    var ov = ovEl ? parseFloat(ovEl.value) : 5;
    var res = $('mpv-results');
    var atc = $('mpv-atc');
    if (sqft <= 0) {
      if (res) res.hidden = true;
      if (atc) atc.disabled = true;
      return;
    }
    var totalSqft = sqft * (1 + ov / 100);
    var need = Math.ceil(totalSqft / cov - 1e-9);
    var qty = Math.max(moq, need);
    // add-ons are charged on what ships: every piece's square feet, not the area typed in (2026-10-13: the sealer was
    // short by up to a piece's coverage, e.g. 210 sq ft charged for 53 slabs = 212 sq ft)
    var sqUnits = Math.ceil(qty * cov - 1e-9);
    var sub = qty * cur.price;
    var grand = sub;

    setText('mpv-qty', qty + ' pcs');
    setText('mpv-sub', need < moq ? 'Minimum order ' + moq + ' pcs' : sqft + ' sq ft + ' + ov + '%');
    setText('mpv-pp', money(cur.price));
    setText('mpv-subtotal', money(sub));

    var sealChk = $('mpv-seal');
    if (sealChk) {
      var sealTot = sqUnits * sealerCents;
      setText('mpv-seal-per', '+ ' + money(sealerCents) + '/sq ft');
      setText('mpv-seal-tot', '+ ' + money(sealTot));
      if (sealChk.checked) grand += sealTot;
    }
    var bushChk = $('mpv-bush');
    if (bushChk) {
      var bushTot = sqUnits * bushCents;
      setText('mpv-bush-per', '+ ' + money(bushCents) + '/sq ft');
      setText('mpv-bush-tot', '+ ' + money(bushTot));
      if (bushChk.checked) grand += bushTot;
    }

    setText('mpv-total', money(grand));
    setText('mpv-total-sqft', money(grand / (qty * cov)) + ' / sq ft');

    root._qty = qty;
    root._sqUnits = sqUnits;
    if (res) res.hidden = false;
    if (atc) atc.disabled = false;
  }

  function getCart() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function cartSectionIds(cart) {
    if (cart && typeof cart.getSectionsToRender === 'function') {
      return cart.getSectionsToRender().map(function (s) { return s.id; }).join(',');
    }
    return 'cart-drawer,cart-icon-bubble';
  }

  function addItems(items, flat) {
    var cart = getCart();
    // flat: the same lines without nesting (parent_id), for a store where nested lines aren't available
    if (flat) items = items.map(function (it) { var o = {}; for (var k in it) if (k !== 'parent_id') o[k] = it[k]; return o; });
    var body = { items: items };
    if (cart) {
      body.sections = cartSectionIds(cart);
      body.sections_url = window.location.pathname;
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok || d.status) throw new Error(d.description || d.message || 'Error');
        return d;
      });
    }).then(function (d) {
      if (cart && typeof cart.renderContents === 'function' && d.sections) {
        if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
        cart.classList.remove('is-empty'); // as product-form.js does: an empty drawer can't trap focus
        cart.renderContents(d);
        document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart: d } }));
      } else {
        window.location.href = '/cart';
      }
      return d;
    });
  }

  function addToCart() {
    if (!root._qty || !cur.id) return;
    var sealChk = $('mpv-seal');
    var bushChk = $('mpv-bush');
    var sealOn = !!(sealChk && sealChk.checked && sealerId);
    var bushOn = !!(bushChk && bushChk.checked && bushId);
    var hasAddon = sealOn || bushOn;

    var items;
    if (hasAddon) {
      var groupId = 'pv-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 6);
      var covStr = root._sqUnits + ' sq ft';
      var forLabel = paverLabel();
      var addonNames = [];
      if (sealOn) addonNames.push('Penetrating Sealer');
      if (bushOn) addonNames.push('Bush-Hammered Finish');
      var paverProps = { _group: groupId, 'Coverage': covStr, 'Add-ons': addonNames.join(', ') };
      items = [{ id: cur.id, quantity: root._qty, properties: paverProps }];
      // nested cart lines: each add-on sits under its paver in the cart, checkout, emails and the order (parent_id =
      // the paver's variant, added in the same request); _group and "Applies to" stay for the theme's cart display
      if (sealOn) items.push({ id: parseInt(sealerId, 10), quantity: root._sqUnits, parent_id: cur.id, properties: { _group: groupId, 'Applies to': forLabel, 'Coverage': covStr } });
      if (bushOn) items.push({ id: parseInt(bushId, 10), quantity: root._sqUnits, parent_id: cur.id, properties: { _group: groupId, 'Applies to': forLabel, 'Coverage': covStr } });
    } else {
      items = [{ id: cur.id, quantity: root._qty }];
    }

    var atc = $('mpv-atc');
    var msg = $('mpv-msg');
    if (atc) { atc.disabled = true; atc.textContent = 'Adding…'; }
    if (msg) msg.hidden = true;
    addItems(items).catch(function (e) {
      // nested lines refused (a store setting or app that doesn't allow them): add the same lines flat
      if (hasAddon && /parent/i.test(e && e.message || '')) return addItems(items, true);
      throw e;
    }).then(function () {
      if (atc) { atc.disabled = false; atc.textContent = 'Add to Cart'; }
    }).catch(function (e) {
      if (atc) { atc.disabled = false; atc.textContent = 'Add to Cart'; }
      if (msg) { msg.hidden = false; msg.innerHTML = '<span class="mpv-err">' + (e.message || 'Could not add to cart.') + '</span>'; }
    });
  }

  function addSample() {
    var sampleAttr = root.getAttribute('data-sample-variant');
    var sampleId = sampleAttr ? parseInt(sampleAttr, 10) : cur.id;
    if (!sampleId) return;
    var btn = $('mpv-sample');
    var msg = $('mpv-msg');
    if (btn && btn.classList.contains('is-loading')) return;
    if (btn) btn.classList.add('is-loading');
    if (msg) msg.hidden = true;
    addItems([{ id: sampleId, quantity: 1 }]).then(function () {
      if (btn) btn.classList.remove('is-loading');
    }).catch(function (e) {
      if (btn) btn.classList.remove('is-loading');
      if (msg) { msg.hidden = false; msg.innerHTML = '<span class="mpv-err">' + (e.message || 'Could not add sample.') + '</span>'; }
    });
  }

  var sqEl = $('mpv-sqft');
  if (sqEl) sqEl.addEventListener('input', calc);
  root.querySelectorAll('input[name="mpv-ov"]').forEach(function (r) { r.addEventListener('change', calc); });
  var sealChk = $('mpv-seal'); if (sealChk) sealChk.addEventListener('change', calc);
  var bushChk = $('mpv-bush'); if (bushChk) bushChk.addEventListener('change', calc);
  var atc = $('mpv-atc'); if (atc) atc.addEventListener('click', addToCart);
  var sampleBtn = $('mpv-sample'); if (sampleBtn) sampleBtn.addEventListener('click', addSample);

  var vr = document.querySelector('variant-radios') || document.querySelector('variant-selects');
  if (vr) {
    vr.addEventListener('change', function () { updateStatic(); calc(); });
    vr.addEventListener('click', function () { setTimeout(function () { updateStatic(); calc(); }, 0); });
  }

  updateStatic();
})();
